
// Atualizado para fornecer mensagens mais claras

const testMistralAPI = async (apiKey: string): Promise<string> => {
  try {
    console.log('Testando chave API Mistral...');
    
    const response = await fetch('https://api.mistral.ai/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'mistral-tiny',
        messages: [
          {
            role: 'user',
            content: 'Teste de conexão'
          }
        ]
      }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        return 'Chave inválida: autenticação falhou';
      }
      throw new Error(`Status: ${response.status}`);
    }

    const data = await response.json();
    return 'Chave válida! Conexão com Mistral bem-sucedida.';
  } catch (error) {
    console.error('Erro no teste da API Mistral:', error);
    if (error instanceof Error) {
      if (error.message.includes('Failed to fetch')) {
        return 'Erro de rede: verifique sua conexão com a internet';
      }
      return `Erro: ${error.message}`;
    }
    return 'Erro desconhecido ao testar a API';
  }
};

const testOpenAIAPI = async (apiKey: string): Promise<string> => {
  try {
    console.log('Testando chave API OpenAI...');
    
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'user',
            content: 'Teste de conexão'
          }
        ]
      }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        return 'Chave inválida: autenticação falhou';
      }
      throw new Error(`Status: ${response.status}`);
    }

    const data = await response.json();
    return 'Chave válida! Conexão com OpenAI bem-sucedida.';
  } catch (error) {
    console.error('Erro no teste da API OpenAI:', error);
    if (error instanceof Error) {
      if (error.message.includes('Failed to fetch')) {
        return 'Erro de rede: verifique sua conexão com a internet';
      }
      return `Erro: ${error.message}`;
    }
    return 'Erro desconhecido ao testar a API';
  }
};

export { testMistralAPI, testOpenAIAPI };
